import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useLayoutEffect, useRef, useState, useContext } from 'react';
import { createPortal } from 'react-dom';
import theme from '../theme.config';
import { EzProviderContext } from '../EzProvider';
export var PortalContext = React.createContext({
  current: null
});
var Provider = PortalContext.Provider;
var portalStyle = theme.css({
  fontFamily: '$defaultFont'
});
var EzPortal = function EzPortal(_ref) {
  var children = _ref.children;
  var mountNode = useRef(null);
  var _useContext = useContext(PortalContext),
    contextValue = _useContext.current;
  var contextRef = useRef(contextValue);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hostNode = _useState2[0],
    setHostNode = _useState2[1];
  var stitchesClassName = useContext(EzProviderContext);
  useLayoutEffect(function () {
    var context = contextRef.current;
    var parentElement = mountNode.current.ownerDocument === (context === null || context === void 0 ? void 0 : context.ownerDocument) ? context : mountNode.current.ownerDocument.body;
    var ownerDocument = parentElement.ownerDocument;
    var portalNode = ownerDocument.createElement('div');
    portalNode.classList.add(portalStyle());
    parentElement.appendChild(portalNode);
    setHostNode(portalNode);
    return function () {
      if (!parentElement.parentElement || !parentElement.contains(portalNode)) return;
      parentElement.removeChild(portalNode);
    };
  }, []);
  useLayoutEffect(function () {
    var _hostNode$classList;
    if (!stitchesClassName) return undefined;
    hostNode === null || hostNode === void 0 || (_hostNode$classList = hostNode.classList) === null || _hostNode$classList === void 0 || _hostNode$classList.add(stitchesClassName);
    return function () {
      var _hostNode$classList2;
      return hostNode === null || hostNode === void 0 || (_hostNode$classList2 = hostNode.classList) === null || _hostNode$classList2 === void 0 ? void 0 : _hostNode$classList2.remove(stitchesClassName);
    };
  }, [hostNode, stitchesClassName]);
  if (!hostNode) return React.createElement("div", {
    ref: mountNode
  });
  return React.createElement(Provider, {
    value: {
      current: hostNode
    }
  }, createPortal(children, hostNode));
};
export default EzPortal;